export default __webpack_public_path__ + "static/arquitectura-mobile-7a9fa9de65965bb0e2b72126abc3dcad.svg";